import React, { memo, useEffect, useState } from "react";
import "./AmenitiesAnalysisPdf.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import ConstantData from "../../../../Utils/Constant";
let amenitiesAnalysisValue = [];

const totalAmenitiesCount = ConstantData.totalAmenitiesCount;
const AmenitiesAnalysisPdf = memo((props) => {
 
  const [amenitiesDataList, setAmenitiesDataList] = useState({});
  const [amenitiesList, setAmenitiesList] = useState({});

  //amenities analysis table data from props
  useEffect(() => {
    if (props && props.data) {
      setAmenitiesList(props.data)
      setAmenitiesDataList({
        ...amenitiesDataList,
        amenitiesDataList: props.amenitiesData,
      });
    }
  }, [props.data]);

  //sorting the amenities
  function sortObject(obj) {
    if (obj && obj !== null) {
      return Object.keys(obj)
        .sort()
        .reduce(function (result, key) {
          result[key] = obj[key];
          return result;
        }, {});
    }
  }

  const getAmenitiesAnalysisValue = (from) => {
    amenitiesAnalysisValue = [];
    let amenitiesDetails = sortObject(
      amenitiesDataList.amenitiesDataList.amenitypercentages
    );
    amenitiesAnalysisValue.push(<TableCell className="freeze" />);
    for (let i = 0; i < Object.keys(amenitiesDetails).length; i++) {
      if (
        Object.values(amenitiesDetails)[i] !== null &&
        Object.values(amenitiesDetails)[i] !== undefined &&
        Object.values(amenitiesDetails)[i] !== ""
      ) {
        amenitiesAnalysisValue.push(
          <TableCell>
            {" "}
            {Object.values(amenitiesDetails)[i] == "0"
              ? "-"
              : Object.values(amenitiesDetails)[i] + " %"}
          </TableCell>
        );
      }
    }
    return from ==="1" ? amenitiesAnalysisValue.splice(1,19) : amenitiesAnalysisValue.splice(20);
  };

  return (
    <div>
      <div className="display-grid">
      {props && props.showLegend ? <div className="amenities-legend">
          <span>
          <CheckCircleOutlineRoundedIcon className="green"/>
          Has the Amenity/Feature
          </span>
          <span>          
          <CancelOutlinedIcon className="red" />
          Does not have the Amenity/Feature
          </span>
        </div>: ''}
        <div className="amenities-tab-table amenities-tab-table-two">
          <div className="table-height-pdf pdf-table">
           {props && props.value === "1" ? (<Table className="table-design amenities-table-pdf">
              <TableHead>
                <TableRow>
                  <TableCell className="freeze rotate head-rotate">
                    Profile Name (Total Amenities)
                  </TableCell>
                  <TableCell className="freeze rotate head-rotate">
                    Additional Lodging
                  </TableCell>
                  <TableCell className="freeze rotate head-rotate width-30">
                    Attractions Descriptions
                  </TableCell>
                  <TableCell className="freeze rotate head-rotate">
                    Back In
                  </TableCell>
                  <TableCell className="freeze rotate head-rotate">
                    Beach Access{" "}
                  </TableCell>
                  <TableCell className="freeze rotate head-rotate">
                    Cabins
                  </TableCell>
                  <TableCell className="freeze rotate head-rotate">
                    Cafe
                  </TableCell>
                  <TableCell className="freeze rotate head-rotate width-30">
                    Cellphone Connectivity
                  </TableCell>
                  <TableCell className="freeze rotate head-rotate">
                    Dog Parks
                  </TableCell>
                  <TableCell className="freeze rotate head-rotate">
                    Dump Station
                  </TableCell>
                  <TableCell className="freeze rotate head-rotate eletric-value-sep" style={{width: '20px'}}>
                    <TableRow>
                      <TableCell></TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>20 Amp</TableCell>
                    </TableRow>
                  </TableCell>
                  <TableCell className="freeze rotate head-rotate eletric-value-sep" style={{width: '25px'}}>
                    <TableRow>
                      <TableCell>Electric Hookup</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>30 Amp</TableCell>
                    </TableRow>
                  </TableCell>
                  <TableCell className="freeze rotate head-rotate eletric-value-sep" style={{width: '20px'}}>
                    <TableRow>
                      <TableCell></TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>50 Amp</TableCell>
                    </TableRow>
                  </TableCell>

                  <TableCell className="freeze rotate head-rotate">
                    EV Charging
                  </TableCell>
                  <TableCell className="freeze rotate head-rotate">
                    Fire Ring
                  </TableCell>
                  <TableCell className="freeze rotate head-rotate">
                    Fishing
                  </TableCell>
                  <TableCell className="freeze rotate head-rotate">
                    GameRoom Arcade
                  </TableCell>
                  <TableCell className="freeze rotate head-rotate">
                    Glamping
                  </TableCell>                  
                  <TableCell className="freeze rotate head-rotate">
                    Golfcart Rentals
                  </TableCell>
                  <TableCell className="freeze rotate head-rotate">
                    Hookups
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                <TableCell className="freeze">Market coverage</TableCell>
                  {amenitiesDataList &&
                    amenitiesDataList.amenitiesDataList &&
                    amenitiesDataList.amenitiesDataList.amenitypercentages &&
                    getAmenitiesAnalysisValue("1")}
                </TableRow>
                {amenitiesAnalysisValue.length === 0 ? (
                  <TableRow>
                    <TableCell
                      style={{ textAlign: "center" }}
                      className="store-no-data"
                    >
                      No records found
                    </TableCell>
                  </TableRow>
                ) : (
                  ""
                )}
                {amenitiesList &&
                  amenitiesList.length > 0 &&
                  amenitiesList.map((rec) => {
                  let count = rec.filter((x, index)=> index < 19 ).filter(x=> x.details !== null).length;
                    return (
                    <TableRow>
                      {rec.filter((x, index)=> index < 19 ).map((data, index) => {
                        return (
                          <>
                            {index === 0 ? (
                              <TableCell className="freeze">
                                {data.profilename}
                                <span>({count}/{totalAmenitiesCount})</span>
                            </TableCell>
                            ) : null}
                            {data ? <TableCell className="electric-hookup-values">
                              {" "}
                              {data.details !== null && data.amenities !== "electrichookup" ? (
                                <CheckCircleOutlineRoundedIcon className="green" />
                              ) 
                              : (
                                <CancelOutlinedIcon className="red" />
                              )}
                            </TableCell>: null}
                          </>
                        );
                      })}
                    </TableRow>

                  )})}
              </TableBody>
            </Table>) : props && props.value === "2" ? (<Table className="table-design amenities-table-pdf">
              <TableHead>
                <TableRow>
                  <TableCell className="freeze rotate head-rotate">
                    Profile Name (Total Amenities *)
                  </TableCell>
                  <TableCell className="freeze rotate head-rotate width-30">
                    Internet Connectivity
                  </TableCell>
                  <TableCell className="freeze rotate head-rotate">
                    Internet Connectivity Payment
                  </TableCell>
                  <TableCell className="freeze rotate head-rotate">
                    Lake-side
                  </TableCell>
                  <TableCell className="freeze rotate head-rotate">
                    Laundry Access
                  </TableCell>
                  <TableCell className="freeze rotate head-rotate">
                    Onsite Propane
                  </TableCell>
                  <TableCell className="freeze rotate head-rotate">
                    Pet Allowed
                  </TableCell>
                  <TableCell className="freeze rotate head-rotate">
                    Picnic Table
                  </TableCell>
                  <TableCell className="freeze rotate head-rotate">
                    Pull In Pull Through
                  </TableCell>
                  <TableCell className="freeze rotate head-rotate">
                    Rec Hall
                  </TableCell>
                  <TableCell className="freeze rotate head-rotate">
                    Self Service CarWash
                  </TableCell>
                  <TableCell className="freeze rotate head-rotate">
                    Sewer Hookup
                  </TableCell>
                  <TableCell className="freeze rotate head-rotate">
                    Shower and Bathrooms
                  </TableCell>
                  <TableCell className="freeze rotate head-rotate">
                    Site Lockers
                  </TableCell>
                  <TableCell className="freeze rotate head-rotate">
                    Sports Courts
                  </TableCell>
                  <TableCell className="freeze rotate head-rotate">
                    Swimming Pool
                  </TableCell>
                  <TableCell className="freeze rotate head-rotate">
                    Tent Camping
                  </TableCell>
                  <TableCell className="freeze rotate head-rotate">
                    Vehicular Access
                  </TableCell>
                  <TableCell className="freeze rotate head-rotate">
                    Water Hookup
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                <TableCell className="freeze">Market coverage</TableCell>
                  {amenitiesDataList &&
                    amenitiesDataList.amenitiesDataList &&
                    amenitiesDataList.amenitiesDataList.amenitypercentages &&
                    getAmenitiesAnalysisValue("2")}
                </TableRow>
                {amenitiesAnalysisValue.length === 0 ? (
                  <TableRow>
                    <TableCell
                      style={{ textAlign: "center" }}
                      className="store-no-data"
                    >
                      No records found
                    </TableCell>
                  </TableRow>
                ) : (
                  null
                )}
                {amenitiesList &&
                  amenitiesList.length > 0 &&
                  amenitiesList.map((rec) => {

                    let count = rec.filter((x, index) => index > 18 ).filter(idx => idx.details !== null ).length;
                    return(
                    <TableRow>
                      {rec.filter((x, indx)=> indx > 18).map((data, index) => {
                        return (
                          <>
                            {index === 0 ? (
                              <TableCell className="freeze">
                                {data.profilename}
                                <span>
                                  ({count}/{totalAmenitiesCount})
                                </span>
                              </TableCell>
                            ) : null}
                            {data ? <TableCell className="electric-hookup-values">
                                      {data.details !== null ? (
                                        <CheckCircleOutlineRoundedIcon
                                          className="green"
                                        />
                                      ) : (
                                        <CancelOutlinedIcon
                                          className="red"
                                        />
                                      )}
                                    </TableCell> : null}
                          </>
                        );
                      })}
                    </TableRow>

            )})}
              </TableBody>
            </Table>) : null}
          </div>
        </div>
      </div>
    </div>
  );
});

export default AmenitiesAnalysisPdf;
